const PHONE_VALIDATION_MESSAGES = {
    en: 'Please provide a valid phone number.',
    de: 'Bitte geben Sie eine gültige Telefonnummer ein.',
    fr: 'Veuillez saisir un numéro de téléphone valide.',
    nl: 'Voer een geldig telefoonnummer in.',
    es: 'Introduzca un número de teléfono válido.',
    it: 'Inserisci un numero di telefono valido.',
    ja: '有効な電話番号を入力してください。',
};
export const getInvalidPhoneNumberMessage = () => {
    const language = (navigator.language || 'en').slice(0, 2).toLowerCase();
    return PHONE_VALIDATION_MESSAGES[language] || PHONE_VALIDATION_MESSAGES.en;
};
